import fontsByName from './fontsByName';
import lightPalette from './lightPalette';
import ThemeImpl from './ThemeImpl';

export default new ThemeImpl(false, lightPalette, fontsByName);
